import { onMounted, onUnmounted } from 'vue'
import { useFormDataStore } from '@/entries/interact-form/stores/formData'

export function useGlobalFunctions() {
  const formDataStore = useFormDataStore()

  onMounted(() => {
    // グローバルスコープに戻るボタンのクリックハンドラを追加
    window.backToQuestions = () => {
      formDataStore.hasCompletedAllQuestions = false
    }
  })

  onUnmounted(() => {
    // グローバル関数の削除
    if (window.backToQuestions) {
      delete window.backToQuestions
    }
  })
}
